import { MetaValue } from './objects';

export function fromKalturaBoolean(meta?: MetaValue) {
  if (!meta) {
    return false;
  }

  return String(meta) === '1' || String(meta) === 'true';
}

export function hasAdultFilter(ksql?: string) {
  if (!ksql) {
    return false;
  }

  return /\badult\b/i.test(ksql);
}

export function shouldIncludeAdult(ksql?: string) {
  return hasAdultFilter(ksql) && (/adult\s*=\s*'?1'?/i.test(ksql!) || /adult\s*!=\s*'?0'?/i.test(ksql!));
}
